/**
 * Author: Srilal S. Siriwardhane
 * Email: SrilalS@99x.io
**/
/**
 * Model Enum to represent the available models.
 * When used it will be extended by the concrete classes of LLM Inference Factory.
 */
export var Model;
(function (Model) {
})(Model || (Model = {}));
export class ModelInfo {
    name;
    description;
    /**
     * @param name - Model name.
     * @param description - Model description. can be null.
    **/
    constructor(name, description) {
        this.name = name;
        this.description = description;
    }
    /**
     * @returns {object} - Returns the JSON representation of the document.
    **/
    toJSON() {
        return {
            name: this.name,
            description: this.description
        };
    }
}
//# sourceMappingURL=Model.js.map